import { FiArrowDown } from "react-icons/fi";

import styles from "./ScrollToBottomButton.module.scss";

interface ScrollToBottomButtonProps {
  onClick: () => void;
}

/**
 * Floating button that returns the chat viewport to the bottom of the message
 * list. Rendered by a route when the user has scrolled away from the bottom.
 */
export default function ScrollToBottomButton({
  onClick,
}: ScrollToBottomButtonProps) {
  return (
    <button
      className={styles.scrollToBottom}
      onClick={onClick}
      title="Scroll to bottom"
      aria-label="Scroll to bottom"
    >
      <FiArrowDown />
    </button>
  );
}
